import { render, staticRenderFns } from "./CiYoutube.vue?vue&type=template&id=00aeedf2&"
import script from "./CiYoutube.vue?vue&type=script&lang=js&"
export * from "./CiYoutube.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports